import logoFull from '../../assets/sp-logo.png'
import logoWhite from '../../assets/sp-logo-white.png'

/** S&P logo lock-up (from the design system) with the divisional label below,
 *  per the brand rule "master mark first, division second". */
export function Logo({ light = false, compact = false }: { light?: boolean; compact?: boolean }) {
  return (
    <div className="flex flex-col items-start gap-1.5">
      <img src={light ? logoWhite : logoFull} alt="Söderberg & Partners" className={compact ? 'h-6 w-auto self-start' : 'h-8 w-auto self-start'} draggable={false} />
      {!compact && (
        <div className={`text-[10px] font-medium uppercase tracking-[0.12em] ${light ? 'text-[#9CC8E2]' : 'text-ink-500'}`}>Wealth Management · Event</div>
      )}
    </div>
  )
}
